import { Helmet } from 'react-helmet';

import LayoutPage from '@/components/Layout/LayoutPage';
import { LegacyRoute } from '@/routes/routesMiddleware';

import CandidateInvitationBatchPage from './CandidateInvitationBatchPage';

/**
 * `/expert_request/:id/invitations/:token` (ENG-6310). The staff MCP prepares
 * invitations and links here; they are emailed only when the staff member who
 * prepared them presses Send on this page.
 *
 * Registered with `allRequiredLegacy`, so a signed-out visitor goes to login and
 * comes back. Who may see, send or cancel the batch is the api's call: only its
 * preparer, signed in as themselves.
 */
const route: LegacyRoute = {
  path: '/expert_request/:id/invitations/:token',

  async action({ params }) {
    const id = params.id!;
    const token = params.token!;

    return (
      <LayoutPage showNav selected="expert_requests">
        <Helmet>
          <title>Send invitations</title>
        </Helmet>
        <CandidateInvitationBatchPage key={token} expertRequestId={id} token={token} />
      </LayoutPage>
    );
  },
};

export default route;
